module.exports = __webpack_public_path__ + "static/media/mode-11.df997e7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-11.svg
// module id = 984
// module chunks = 2